import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountConversationalAgent: {}
  },
  mutations: {
    SET_ACCOUNT_CONVERSATIONAL_AGENT (store, item) {
      store.accountConversationalAgent = item
    }
  },
  getters: {
    getAccountConversationalAgent: (store, getters) => {
      return store.accountConversationalAgent
    }
  },
  actions: {
    /*
    getAccountConversationalAgent
    */
    getAccountConversationalAgent ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-conversational-agent`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountConversationalAgent
    */
    updateAccountConversationalAgent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-conversational-agent`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountConversationalAgent.js